<template>
    <v-container fluid class="p-0" id="app">
        <vue-headful
                :og-locale="$i18n.locale"
                image="<%= BASE_URL %>favicon.png"
        ></vue-headful>
        <router-view></router-view>
        <!--        <b-alert :show="alertShown" :variant="alertVariant" id="alertTopBar">-->
        <!--            <p>{{alertMessage}}</p>-->
        <!--        </b-alert>-->

        <v-dialog v-model="showAlertDialog"
                  max-width="290">
            <v-card>
                <v-card-text class="p-3">{{alertMessage}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <div v-if="alertActions">
                        <v-btn v-for="(action, index) in alertActions"
                               v-bind:key="'alert_action_' + index"
                               text
                               :color="action['color'] || 'rgb(142, 118, 91)'"
                               @click="afterDialog(index)">
                            {{action['text'] || $t('close')}}
                        </v-btn>
                    </div>
                    <v-btn v-else
                           text
                           color="rgb(142, 118, 91)"
                           @click="afterDialog">
                        {{$t('close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="loadingGreyOut" v-show="isLoading">
            <moon-loader color="#8E765B"></moon-loader>
        </div>

        <NotificationRecordModal></NotificationRecordModal>
    </v-container>
</template>

<script>
    import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
    import NotificationRecordModal from "./components/NotificationRecordModal";

    export default {
        name: 'App',
        components: {
            NotificationRecordModal,
            MoonLoader,
        },
        data() {
            return {
                notificationInterval: null,

                // Alert Dialog
                showAlertDialog: false,
                alertMessage: null,
                alertHandler: null,
                alertActions: null
            };
        },
        beforeMount() {
            let locale = this.$cookie.get('locale') || 'en';

            let l = (new URL(document.location)).searchParams.get('locale');
            if (l) {
              locale.value = l;
              window.history.replaceState(null, null, window.location.pathname+window.location.hash);
            }

            this.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
            this.$i18n.locale = locale;

            let browserToken = this.$cookie.get('DT') || this.guid();
            this.$cookie.set('DT', browserToken, {expires: '90D', samesite: 'Strict', secure: true});
        },
        mounted() {
            this.$eventHub.$on('showAlertMessage', ({message, handler, actions}) => {
                this.alertMessage = message || this.$t('error_msg');
                this.alertHandler = handler;
                this.alertActions = actions;
                this.showAlertDialog = true;
            })

            // Add the Kaltura player for GYM Preview video player
            // let kWidgetScript = document.createElement('script')
            // kWidgetScript.setAttribute('src', 'https://cdnapi.kaltura.com/p/2364572/sp/236457200/embedIframeJs/uiconf_id/41657502/partner_id/2364572')
            // document.head.appendChild(kWidgetScript)
        },
        computed: {
            // Loading Spinner
            isLoading() {
                return this.$store.state.loadingSpinner.isLoading;
            },
        },
        methods: {
            guid() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            },
            afterDialog() {
                this.showAlertDialog = false;
                if (this.alertHandler) {
                    this.alertHandler();
                }
            },
        },
    }
</script>
<style lang="less">
    @import "./styles/client/main";

    #app {
        font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        padding-left: 0;
        padding-right: 0;
        height: 100%;
    }

    #alertTopBar {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 2000;
        font-size: 2em;
    }

    #loadingGreyOut {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background-color: rgba(50, 50, 50, 0.8);

        .v-spinner {
            position: relative;
            top: 45%;
            left: 47%;
        }
    }

    .v-data-footer__select {
      flex: 0 0 auto;
    }
</style>
<style>
    @import url('https://fonts.googleapis.com/css?family=Montserrat:200,300,400,500,600,700,900|Roboto&display=swap');
</style>
